import { render, staticRenderFns } from "./comNotice.vue?vue&type=template&id=7ed1e25f&scoped=true"
import script from "./comNotice.vue?vue&type=script&lang=js"
export * from "./comNotice.vue?vue&type=script&lang=js"
import style0 from "./comNotice.vue?vue&type=style&index=0&id=7ed1e25f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed1e25f",
  null
  
)

export default component.exports